import type { PlotShape } from "../plot/PlotShape"
import type { Rectangle } from "./Rectangle"

export type Page = {
  shapes: PlotShape[]
  bleed?: number
} & Rectangle
